import PropTypes from "prop-types"
import { DATE } from "helpers/shapes"

export const DATA = PropTypes.arrayOf(PropTypes.shape({
  date: DATE.isRequired,
  0: PropTypes.number,
  1: PropTypes.number,
  2: PropTypes.number,
  3: PropTypes.number,
  4: PropTypes.number,
}))

export const METRICS = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.func.isRequired,
  })).isRequired,
}))

export const SELECTED_METRIC = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.func.isRequired,
})

export const SELECTED_GROUP = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
})

export const ITEMS = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  noData: PropTypes.bool,
  isUmodeled: PropTypes.bool,
}))

export const DETAILS_ITEMS = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string,
  color: PropTypes.string,
  defaultOpen: PropTypes.bool,
  fn: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    fn: PropTypes.func.isRequired,
  })),
}))

export const DETAILS_DATA = PropTypes.arrayOf(PropTypes.shape({
  attribution: PropTypes.object,
  categories: PropTypes.object,
  factors: PropTypes.object,
  metrics: PropTypes.object,
  summary: PropTypes.object,
}))

export const DOWNLOAD_FILENAME = PropTypes.shape({
  chart: PropTypes.string,
  table: PropTypes.string.isRequired,
})

export const POSITIONS_DISPLAY_TYPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
})

const DOWNLOAD_DATA_ROW = PropTypes.arrayOf(
  PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
)

const SHEETS_DOWNLOAD_SHAPE = PropTypes.shape({
  name: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(DOWNLOAD_DATA_ROW).isRequired,
})

export const TABLE_DOWNLOAD_DATA = PropTypes.shape({
  sheets: PropTypes.arrayOf(SHEETS_DOWNLOAD_SHAPE),
})
